import makeStyles from '@mui/styles/makeStyles'

const cardShape = 'polygon(0% 0%, 100% 0%, 100% calc(100% - 25px), calc(100% - 25px) 100%, 0% 100%)'

export const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  verticalBannerCtn: {
    width: '100%',
    padding: spacing(2),
    backgroundColor: ({ bg }) => bg,
    height: typography.pxToRem(345),
    boxSizing: 'border-box'
  },
  verticalBannerTxtCtn: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%'
  },
  verticalBannerTitle: {
    color: ({ text }) => text,
    fontSize: typography.pxToRem(18),
    fontWeight: 700,
    lineHeight: 24 / 18
  },
  verticalBannerDescription: {
    color: ({ text }) => text,
    marginTop: spacing(1),
    ...typography.body.m,
    marginBottom: spacing(2),
    lineClamp: 2,
    WebkitLineClamp: 2,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical'
  },
  verticalBannerImg: {
    width: '100%',
    height: '150px',
    objectFit: 'cover',
    borderRadius: spacing(1)
  },
  verticalBannerCard: {
    clipPath: cardShape,
    height: '100%',
    display: 'flex',
    gap: spacing(2),
    flexDirection: 'column',
    borderRadius: 0,
    width: '100%',
    maxWidth: typography.pxToRem(327),
    backgroundColor: ({ bg }) => bg,
    boxSizing: 'border-box'
  },
  verticalBannerEdge: {
    clipPath: cardShape,
    height: typography.pxToRem(345),
    width: '100%',
    maxWidth: typography.pxToRem(327),
    margin: 'auto',
    backgroundColor: ({ bg }) => bg,
    boxSizing: 'border-box'
  }
}))
